export const mapItemArray = (prop) => (fn) => {
  return ({ item }) => {
    if (item[prop]) {
      const newArray = item[prop].map((arrayItem, index) => {
        return fn(arrayItem, item, index) || arrayItem
      })
      return {
        item: {
          ...item,
          [prop]: newArray
        }
      }
    }
    return null
  }
}

export const mapPictures = mapItemArray('pictures')
// TODO: Remove the additionalCTA support
export const mapAdditionalCTA = mapItemArray('additionalCTA')
